import { useInactivityLogout } from '../../hooks/useInactivityLogout';

/**
 * Layout wrapper para páginas de admin con auto-cierre de sesión (2 minutos)
 */
export const AdminLayout = ({ children }) => {
  // Auto-cierre de sesión por inactividad (2 minutos para panel de control)
  useInactivityLogout({
    timeoutMinutes: 2,
    logoutPath: '/admin/login',
    tokenKey: 'konemed_admin_token',
    additionalKeys: ['konemed_admin_username'],
    warningMessage: 'Tu sesión de administrador ha expirado por inactividad (2 minutos)'
  });

  return children;
};
